module.exports = __webpack_public_path__ + "static/media/main_slider_1.e4b7e8a2.jpg";